export const numericValue = (value) => {
  try {
    return value?.replace(/[^0-9.]/g, '');
  } catch (error) {
    console.log(error);
    return value;
  }
};
